import { classNames } from "primereact/utils";
import { Message } from "primereact/message";

import { Icon } from "@/ds";
import {
  COLUNA_DESCRICAO,
  COLUNA_ID,
  COLUNA_STATUS,
  COLUNA_TIPO,
  TIPO_ROTULO,
} from "./servicos-materiais-secao.constants";
import tabela from "../planejamento-controle.tabela.module.scss";
import styles from "./servicos-materiais-secao.module.scss";
import type { ServicosMateriaisSecaoProps } from "./types-servicos-materiais-secao";

export function ServicosMateriaisSecaoView({
  titulo,
  itens,
  impedimentos = [],
  testIds,
}: ServicosMateriaisSecaoProps) {
  const impedimento = impedimentos[0];
  if (itens.length === 0 && !impedimento) return null;

  return (
    <section className={styles.secao} data-testid={testIds.secao}>
      {impedimento ? (
        <Message
          className="p-message-block"
          severity="error"
          icon={<Icon name="times-circle" size={18} />}
          text={impedimento.motivo}
          data-testid={testIds.impedimento}
        />
      ) : null}
      {itens.length > 0 ? (
        <>
          <h3 className={styles.titulo}>{titulo}</h3>
          <div className={tabela.tabelaWrap}>
            <table
              className={classNames(tabela.tabela, styles.tabela)}
              data-testid={testIds.tabela}
            >
              <thead>
                <tr>
                  <th scope="col">{COLUNA_TIPO}</th>
                  <th scope="col">{COLUNA_ID}</th>
                  <th scope="col">{COLUNA_DESCRICAO}</th>
                  <th scope="col">{COLUNA_STATUS}</th>
                </tr>
              </thead>
              <tbody>
                {itens.map((item) => (
                  <tr key={`${item.tipo}-${item.codigo}`} data-testid={testIds.item}>
                    <td>{TIPO_ROTULO[item.tipo]}</td>
                    <td>{item.codigo}</td>
                    <td>{item.descricao}</td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </section>
  );
}
